import * as React from 'react';
import { Alert, Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { ReportAlias } from '../../../types/ReportAlias/ReportAlias';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';
import { RecordAccessControl } from '../../../types/RecordAccessControl/RecordAccessControl';
import { PowerBiObjectType } from '../../../types/Common/PowerBiObjectType';

type DeleteAccessControlEntryModalProps = {
    dispatch: Dispatch;
    accessControlEntry: RecordAccessControl;
    recordId: string;
    recordType: PowerBiObjectType;
    modalBody: any;
    okButton: any;
    hideModal: any;
    showModal: boolean;
}

interface DeleteAccessControlEntryModalState {
    isLoading: boolean;
    validated: boolean;
    aliasId: string;
    hasError: boolean;
    errorMessage: string;
}

class DeleteAccessControlEntryModal extends React.Component<DeleteAccessControlEntryModalProps, DeleteAccessControlEntryModalState> {
    public constructor(props: DeleteAccessControlEntryModalProps) {
        super(props);
        this.state = {
            isLoading: false,
            validated: false,
            aliasId: '',
            hasError: false,
            errorMessage: '',
        }
    }

    private handleDeleteAliasModalOkButton() {
        this.resetState();

        let url = `./api/reports/${this.props.recordId}/members/${this.props.accessControlEntry?.accessControlEntryId}`;
        if (this.props.recordType == PowerBiObjectType.Dashboard) {
            url = `./api/dashboards/${this.props.recordId}/members/${this.props.accessControlEntry?.accessControlEntryId}`;
        }

        axios
        .delete<RecordAccessControl>(url)
        .then((response: { data: RecordAccessControl; }) => {
            const { data } = response;
                this.props.okButton();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ?? e.message;

            this.setState({validated: false}); 
            this.setState({errorMessage: errorMessage});
            this.setState({hasError: true});
        });
    }

    private handleCloseModal() {
        this.resetState();
        this.props.hideModal();
    }

    // Reset the modal state to default
    private resetState() {
        this.setState({
            errorMessage: "",
            hasError: false,
        });
        this.setState({validated: false});
    }

    public render() {

        return(
            <Modal show={this.props.showModal} onHide={() => this.handleCloseModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Delete Access Control Entry
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <Alert variant='danger' show={this.state.hasError ? true : false}>
                                    {this.state.errorMessage}
                                </Alert>
                            </Col>
                        </Row>
                        <Row>
                            {this.props.modalBody}
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.handleCloseModal()}>
                        Close
                    </Button>
                    <Button
                        variant="danger"
                        disabled={this.state.isLoading}
                        onClick={() => this.handleDeleteAliasModalOkButton()}
                    >
                        {this.state.isLoading ? 'Loading...' : 'Delete'}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default DeleteAccessControlEntryModal;
